module.exports = __webpack_public_path__ + "media/img/vca/categories/popular-105744541133f3cb530d363f8b49df99.png";